import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import Logo from '../images/logo.png';
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { FaFacebook, FaInstagramSquare, FaTwitter } from "react-icons/fa";


const Header = () => {
  return (
    <>
      <section className='top_header'>
        <Container>
          <div className="">
            <div className="top_header_content">
              <ul>
                <li><FiPhoneCall /> <Link to="tel:(833) 320-1199">(833) 320-1199</Link></li>
                <li><TfiEmail /> <Link to="#">sales@alleventsinsure.com</Link></li>
              </ul>
              <ul className='social_icons'>
                <li><FaFacebook /></li>
                <li><FaInstagramSquare /></li>
                <li><FaTwitter /></li>
              </ul>
            </div>
          </div>
        </Container>
      </section>
      <header className='main_header'>
        <Navbar collapseOnSelect expand="lg" >
          <Container className='header-container'>
            <Navbar.Brand href="/" className='navbar-logo'><img src={Logo} alt="" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" className='main-nav'>
              <Nav className='main_navbar'>
                <NavLink to='/' className='nav_link'>Home</NavLink>
                <NavLink to='about' className='nav_link'>About Us</NavLink>
                <NavLink to="/form/personal" className='nav_link'>personal</NavLink>
                <NavLink to="/form/professional" className='nav_link'>professional</NavLink>
                <NavLink to="/form/sports" className='nav_link'>sports</NavLink>
                <NavLink to="/form/vendor" className='nav_link'>vendor</NavLink>
              </Nav>
              <Nav className='main_navbar2'>
              </Nav>
              <button className='custom_btn'>
                <NavLink to='/form-links'> get started</NavLink>
              </button>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  )
}

export default Header


